// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1WnZQ","icon":"SortAdornment_icon__2sJ7t","up":"SortAdornment_up__3Nk35","down":"SortAdornment_down__21FcT","active":"SortAdornment_active__3djPa"};